export default __webpack_public_path__ + "static/media/sec-1-ar.51aad3df.png";